const base = "/school/academic-management";

export default [
    {
        title: "Academic sessions",
        description: "Create school sessions and set their dates.",
        path: `${base}/academic-sessions`,
        icon: "fa fa-folder"
    },
    {
        title: "Terms",
        description: "Configure terms within each academic session.",
        path: `${base}/terms`,
        icon: "fa fa-folder"
    },
    {
        title: "Classes",
        description: "Create classes and set their assessment weighting.",
        path: `${base}/classes`,
        icon: "fa fa-folder"
    },
    {
        title: "Class options",
        description: "Create and organize the options available for each class.",
        path: `${base}/options`,
        icon: "fa fa-folder"
    },
    {
        title: "Class arms",
        description: "Create and manage arms within each class option.",
        path: `${base}/arms`,
        icon: "fa fa-folder"
    },
    {
        title: "Subjects",
        description: "Assign subjects and configure the school curriculum.",
        path: `${base}/subjects`,
        icon: "fa fa-folder"
    },
    {
        title: "Psychomotor skills",
        description: "Configure psychomotor skills for student assessment.",
        path: `${base}/psycomotor-skills`,
        icon: "fa fa-folder"
    },
    {
        title: "Conduct",
        description: "Set up conduct categories used in student evaluations.",
        path: `${base}/conduct`,
        icon: "fa fa-folder"
    },
    {
        title: "Grade scale",
        description: "Define grading scales and result assessment bands.",
        path: `${base}/grade-scale`,
        icon: "fa fa-folder"
    },
    {
        title: "Mock exams",
        description: "Create and configure mock examinations for students.",
        path: `${base}/mock-exam`,
        icon: "fa fa-folder"
    },
    {
        title: "Mock exam subjects",
        description: "Select and manage subjects included in mock exams.",
        path: `${base}/mock-exam-subjects`,
        icon: "fa fa-folder"
    }
];
